// mediaWrapper.js: Simple responsive iframes
// MIT license http://www.opensource.org/licenses/mit-license.php/
// @author Matthew A. K. Smith http://www.akselkreis.com
var bogo_less_pd = $('.cart-item[data-bogo="false"]').length;

$(window).bind("load resize",function(e){
if ($('.slide_tabs_cstm').length > 0) {
        var screenwidth = $(window).outerWidth();
        var containerwidth = $('.page-width').width();
        var calculated = screenwidth - containerwidth;
        var finalval = calculated / 2;
       $('.slide_tabs_cstm .sub-slide-inner').css('margin-left', finalval + "px");
      
      
      }
if(window.location.href.indexOf("blogs")> -1){
  if($(window).width() < 767){
   if(!$('.temp-article iframe').parents().hasClass('mediaWrapper')) {
    $('.temp-article iframe').mediaWrapper({
		intrinsic:	true,
		baseWidth	:16,
		baseHeight	:9
	});
   }
  }else{
    if($('.temp-article iframe').parents().hasClass('mediaWrapper')) {
    $('.temp-article iframe').unwrap();
    $('.temp-article iframe').removeAttr('style');
    }
  }
}
/************* homepage video for banner url change *************/
var video_src =  $(".video.first-video.banner-video").find("source").attr("src");

   if($(window).width() < 767){
       var mobile_video_url =  $('.dots_on_desktop.dots_on_mobile .video_container').attr('data-mobile-url');
        var mobile_poster_url  =  $('.dots_on_desktop.dots_on_mobile .video_container').attr('data-mobile-poster');
      if(mobile_video_url != ''){
       if(video_src != mobile_video_url){
            var video = $(".video.first-video.banner-video");
            video.find("source").attr("src", mobile_video_url);
            video.attr("poster", mobile_poster_url);
            video[0].load();
       }
        
       }
   }else{
   var desktop_video_url =  $('.dots_on_desktop.dots_on_mobile .video_container').attr('data-desktop-url');
    var desktop_poster_url  =  $('.dots_on_desktop.dots_on_mobile .video_container').attr('data-desktop-poster');
      if(desktop_video_url != ''){
       var video = $(".video.first-video.banner-video");
       if(video_src != desktop_video_url){
        video.find("source").attr("src", desktop_video_url);
         video.attr("poster", desktop_poster_url);
        video[0].load();
       
   }
      }else{
   var mobile_video_url =  $('.dots_on_desktop.dots_on_mobile .video_container').attr('data-mobile-url');
        var mobile_poster_url  =  $('.dots_on_desktop.dots_on_mobile .video_container').attr('data-mobile-poster');
      if(mobile_video_url != ' '){
       if(video_src != mobile_video_url){
            var video = $(".video.first-video.banner-video");
            video.find("source").attr("src", mobile_video_url);
            video.attr("poster", mobile_poster_url);
            video[0].load();
       }
        
       }
    }
  }
/************* homepage video for banner  end*************/
});

$(document).ready(function(){
  /** menu selecte popup **/
  $('.active-arrow a.popup-open,.menu-drawer__menu li summary.popup-open').click(function(e){
   
 e.preventDefault();       

    $('.mega-menu_custom').addClass('fixed');
   $('body').addClass('selector_active');
   var popup_id = $(this).attr('href');
    var popup_id1 = $(this).attr('data-url')
  if(popup_id != undefined){
$('.model-menu'+popup_id).addClass('active');
  }else{
$('.model-menu'+popup_id1).addClass('active');
}
});
$('p.title.open_menu').click(function(){
    $(this).parents('.inner_content_popup').find('.list-unstyled').slideToggle();
$(this).toggleClass('active');
})
$('.inner_content_popup .close_popup').click(function(){
$('body').removeClass('selector_active');
    $(this).parents('.model-menu').removeClass('active');
    $(this).parents('.model-menu').find('.open_menu').removeClass('active');
    $(this).parents('.model-menu').find('.list-unstyled').hide();
})
 /** menu selecte popup end**/
  /** collection page js **/
if(window.location.href.indexOf("collections") > -1){
$(document).on('click','.load_more_main',function(){
   var url = $(this).parents('.load_more_btn').find('.pagination_next_link .load_more_next_btn').attr('href');
    
      $.ajax({
            type: 'GET',
            url: url,
            success:function(data){
             $('#product-grid').append($(data).find('#product-grid').html());
              var link_next = $(data).find('.load_more_btn .pagination_next_link .load_more_next_btn').attr('href');
                console.log(link_next);
                if(link_next != undefined){
                $('.load_more_btn .pagination_next_link .load_more_next_btn').attr('href',link_next);
                }else{
                    $('.load_more_btn').hide();
                }
            }
        });
})
$('.mobile-facets__open').click(function(){
    $('.facets-vertical #main-collection-filters').addClass('open').removeClass('filter_hide');
    $('.facets-vertical .product-grid-container #product-grid').removeClass('grid--4-col-desktop').addClass('grid--3-col-desktop');
   $('.close_filter').addClass('active')
});
$('.close_filter').click(function(){
   $('.facets-vertical #main-collection-filters').removeClass('open').addClass('filter_hide');
    $('.facets-vertical .product-grid-container #product-grid').addClass('grid--4-col-desktop').removeClass('grid--3-col-desktop');
 $('.close_filter').removeClass('active')
})
  /** collection custom filter **/
  $('.main_collection_custom_filter details#Details-HeaderMenu-1 a').click(function(e){
    e.preventDefault();
   var current_url = window.location.href;
    
  var col_url =  $(this).attr('href');
        var selected_tag = $(this).attr('data-tag');
   var tag_of_url = current_url.split(col_url)[1]
   if(tag_of_url.indexOf('?')>-1){
    tag_of_url  = tag_of_url.split('?')[0]
   }
if(tag_of_url == ''){
        $(this).attr('data-tag')
        var new_url =col_url+'/'+selected_tag;
     window.location.replace(new_url);
    }else{
  if(tag_of_url.indexOf('collection-filter') > -1 ||tag_of_url.indexOf(selected_tag)>-1){
    var new_url =col_url+'/'+selected_tag;
  }else{
      var new_url =col_url+tag_of_url+'+'+selected_tag;
  }
 window.location.replace(new_url);
    }

})
// $('.main_collection_custom_filter details#Details-HeaderMenu-1 a,.inner_main_collection_tab_filter a').click(function(e){
//     e.preventDefault();
//    var current_url = window.location.href;
    
//   var col_url =  $(this).attr('href');
//         var selected_tag = $(this).attr('data-tag');
//    var tag_of_url = current_url.split(col_url)[1]
//    if(tag_of_url.indexOf('?')>-1){
//     tag_of_url  = tag_of_url.split('?')[0]
//    }
//   if (tag_of_url.indexOf('+') > -1){
//       tag_of_url =tag_of_url.split('+')
//       console.log(tag_of_url)
      
//       if ($(this).parents().hasClass('custom_filters')){
//           if(tag_of_url[0].indexOf('collection-filter')>-1){
//           var tag_of_url =col_url+'/'+selected_tag+'+'+tag_of_url[1];
//             //  console.log(tag_of_url)
//            window.location.replace(tag_of_url);
//           }else{
//            var new_url =col_url+tag_of_url[0]+'+'+selected_tag;
//              // console.log(new_url)
//          window.location.replace(new_url);
//           }
//       }else if($(this).parents().hasClass('inner_main_collection_tab_filter')){
//        if(tag_of_url[0].indexOf('collection-filter')>-1){
//           var new_url =col_url+tag_of_url[0]+'+'+selected_tag;
//              // console.log(new_url)
//       window.location.replace(new_url);
//           }else{
//            var new_url =col_url+'/'+selected_tag+'+'+tag_of_url[1];
//             //  console.log(new_url)
//        window.location.replace(new_url);
//           }
          
//       }
//   }else{
      
//     if(tag_of_url == ''){
//         $(this).attr('data-tag')
//         var new_url =col_url+'/'+selected_tag;
//      window.location.replace(new_url);
//     }else{
//   if(tag_of_url.indexOf('collection-filter') > -1 ||tag_of_url.indexOf(selected_tag)>-1){
//     var new_url =col_url+'/'+selected_tag;
//   }else{
//       var new_url =col_url+tag_of_url+'+'+selected_tag;
//   }
//  window.location.replace(new_url);
//     }
//   }

// })
}
 /** collection page js end**/
  
 $("a[href*='http://']:not([href*='"+location.hostname+"']), a[href*='https://']:not([href*='"+location.hostname+"'])").attr('rel','nofollow');
  var hide_mobile_bundle_pd = $('cart-drawer .active_bundel .grid__item.bundle-product-list.cart-hidden').length
            var hide_bundle_pd =$('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list.cart-hidden').length
            var total_hide_bundle_pd = hide_mobile_bundle_pd+hide_bundle_pd;
           // console.log(total_hide_bundle_pd);
            var total_mobile_bundle_pd = $('cart-drawer .active_bundel .grid__item.bundle-product-list').length;
            var total_bundle_pd = $('cart-drawer .main_bundle_wraoer-container li.grid__item.bundle-product-list').length;
            var total_bundle_pd_main = total_mobile_bundle_pd+total_bundle_pd;
            //console.log(total_bundle_pd_main);
            
            var total_show_pd = total_bundle_pd_main-total_hide_bundle_pd;
            //console.log(total_show_pd);
            if(total_show_pd < 1){
                $('cart-drawer .drawer_upsells').addClass('hide_active');
            }else{
                
                 $('cart-drawer .drawer_upsells').removeClass('hide_active');
                
            }
    /******** hide the reviews text **********************/
  if(window.location.href.indexOf("products") > -1){
/** pattern slider **/
$(".pattern-images-slider,fieldset.variant_slider").flickity({
  contain: true,
  pageDots: false,
  accessibility: true, //true by default
  autoPlay: false, // advance cells every 3 seconds
  groupCells: true
});
/** pattern slider end**/
  var refreshId = setInterval(hide_reviews, 500);
  function hide_reviews() {
 var count_review = $('.jdgm-prev-badge').attr('data-number-of-reviews')
  var reviews_html =$('.jdgm-prev-badge__text').html(count_review);
  if($('.jdgm-prev-badge__text') > 0){
  $('.jdgm-prev-badge__text').removeClass('hidden')
  clearInterval(refreshId);
  }
  }
    /** open review box ***/
    if(window.location.href.indexOf('judgeme_review_source') > -1){
    setTimeout(function(){$('.review_click').trigger('click');
   var url=window.location.href.split('?judgeme_review_source')[0];                       
        window.history.pushState({href: window.location.href}, '', url);                  
                         },1000)
}
    /** open review box end***/
  }
 /******** hide the reviews text end**********************/
/********** video auto play ************/
$("video").each(function(){
    this.paused ? this.play() : this.pause();
});

/*********video auto play End ************/
/************** Currency switcher Ajax **********/
$(window).bind('load',function(){
    $.ajax({
      method: "GET",
      url:"?sections=desktop_curreny_switcher",
      async: true,
      success: function(data) {
       $(".desktop_currency_switcher").html($(data.desktop_curreny_switcher).html());
      }
  });
 $.ajax({
      method: "GET",
      url:"?sections=mobile_currency_switcher",
      async: true,
      success: function(data) {
         
       $(".mobile_switcher .mobile_dynamic_switcher").html($(data.mobile_currency_switcher).html());
      }
 });
});
/************** Currency switcher Ajax End**********/

/************** collapse tab js  **********/
 $('details').on('click',function(e){
 $(this).attr('open');
 $(this).parent('.accordion').siblings().find('details').removeAttr('open');
  });

/************** collapse tab js  END**********/

  /** horizontal accordian **/
 $(".item, .info").first().addClass("active active_open");
  
  // Show First Info
  $(".info").first().show().animate({ width: "100%" },function(){$(this).addClass("active active_open")});
  // Show Info On Click
  $(".item").click(function () {
   $(this).addClass("active").siblings(".item").removeClass("active active_open");
   $('.info').removeClass("active active_open");
    $(this).prev().show().addClass('active').animate({ width: "100%"}, function () { 
      $(this).addClass('active_open') }).siblings(".info").removeClass('active_open').animate({ width: 0 }, function () {
      $(this).hide().removeClass('active');
      });
   
  });
  /** horizontal accordian END HERE**/
  /********** Mega menu js ***************/
$(document).on('click','details#Details-menu-drawer-menu-item-mobile-switcher',function(){
    $('.currency-mobile-switcher').addClass('menu-opening');
});
  $(document).on('click','.sub-menu-links .active-arrow a.mega-menu__link.mega-menu__link--level-2.grand_child',function(e){
    e.preventDefault();
    var child_handle = $(this).attr('data-childlink');
    var main_handle = $(this).attr('data-title');
    $('.let_content_container1 .left_content_container_sub .level-2-sub-child').hide();
    $('.let_content_container1 .left_content_container_sub .level-2-sub-child[data-main="'+main_handle+'"][data-child="'+child_handle+'"]').show();
    if(child_handle!= undefined){
    $('.let_content_container1').show();
    }else{
    $('.let_content_container1').hide();
    }
    });
  // $('.level-2-has-child').click(function(e){
  //  e.preventDefault();
  //  // $(this).next('ul').toggle(); 
  //      let $this = $(this);  
  //     if ($this.next().hasClass('active')) {
  //         $this.next().removeClass('active');
  //         $this.next().slideUp(350);
  //     } else {
  //         $this.parent().parent().find('ul').removeClass('active');
  //         $this.parent().parent().find('ul').slideUp(350);
  //         $this.next().toggleClass('active');
  //         $this.next().slideToggle(350);
  //     }
  //     var isActive = $(this).hasClass("active");
		// 	$('.level-2-has-child').removeClass('active')
  //     if (!isActive) {
  //       $(this).toggleClass('active');
  //     }    
  // });
  
  $(".desktop-menu-burger-icon").click(function () {
    $('body').toggleClass('scroll-hide');
    $(this).find(".menu-open-trigger").toggle();
    $(this).find(".menu-close-trigger").toggle();
    $(".mega-menu_custom").toggleClass("show-menu");
    $('.mega-menu_custom li .mega-menu[data-has-child="true"]').first().find('.list-menu__item').trigger('click');
    $('.let_content_container').hide();
     
  });
  
$(document).on('click','.header__menu-item.list-menu__item',function(){
     console.log('hellonew3');
    var attr = $(this).attr('data-has-child');
    console.log(attr);
    if (typeof attr !== 'undefined' && attr == 'true') {
    var data_menu_active = $(this).parent(".mega-menu.mega-menu-1").attr("data-active-menu");
      console.log("test=" +data_menu_active);
      $('.let_content_container').hide();
    $(this).parents('.container_nav_magamenu').removeClass('currency_active');
    $('.inner-list-menu').removeClass('currency_language_active');
    $('.sub-menu-links').removeClass('currency_language_active');
    $('.let_content_container').removeClass('currency_language_active');
    if(data_menu_active == undefined){
      $('.let_content_container1').hide();
    }else{
     $('.let_content_container1').show(); 
    }
      $(".let_content_container").removeClass("active_left_cnt");
    $('.let_content_container .level-2-sub-child').hide();
    $('.let_content_container1 .show_menu_desktop li .level-2-sub-child').hide();
    $('.let_content_container1 .show_menu_desktop li .level-2-sub-child[data-main="'+data_menu_active+'"]:first').show();
    $(this).parent(".mega-menu-1").addClass("active-arrow");
    $('.language_switcher').removeClass('active_language_switcher');
    $(".mega-menu-1").not($(this).parent(".mega-menu-1")).removeClass("active-arrow");
    $('.currency_switcher_with_contery').removeClass('active_main_currency_switcher');
    $('.left_content_container_sub').removeClass('hide_left_content');
    $(".currencies_menu").removeClass("active_currency_container");
    $(".desktop_currency_switcher .disclosure").removeClass('show_switcher');
    $('.let_content_container2').hide();
    $('.let_content_container2 .level-2-sub-child[data-title="'+data_menu_active+'"]').parents('.let_content_container2').show();
    $(".mega-menu__list.show_menu_desktop").removeClass("active_sublink");
     $('.mega-menu__list.show_menu_desktop[data-menu="'+data_menu_active +'"]').addClass("active_sublink");
    }
  });

  $(document).mouseup(function(e) {
    var container = $(".disclosure__list.list-unstyled");
    if(!$('.disclosure__button').is(e.target)){
      if (!container.is(e.target) && container.has(e.target).length === 0) 
      {
      $('.disclosure__list-wrapper').removeClass('show_mobile_contries');
      }
    }
    var container = $(".model-inner");
    if(!$('.popupOpen').is(e.target) && !$('.popupOpen').is(e.targer)){
      if (!container.is(e.target) && container.has(e.target).length === 0 ) 
      {
     // $('.model').hide();
        $('.model').removeClass('active');
      $("body").removeClass('pop-open');
      }
    }
       var container = $(".model-menu .inner_content_popup");
      if (!container.is(e.target) && container.has(e.target).length === 0 ) 
      {
        $('.model-menu').removeClass('active');
      $("body").removeClass('selector_active');
      }
    });  
  
  var ele = $(".mega-menu_custom .inner-list-menu li div.mega-menu");
  for (var i = 0; i < ele.length; i++) {
    $(ele[0]).addClass("active-arrow");
    var data_menu_active = $(".mega-menu.mega-menu-1.active-arrow").attr("data-active-menu");
      $('.mega-menu__list.show_menu_desktop[data-menu="'+data_menu_active +'"]').addClass("active_sublink");
  }
  $(".header__menu-item,.mega-menu").hover(function () {
    $(this).addClass("show_arrow");
    $(".header__menu-item,.mega-menu").not($(this)).removeClass("show_arrow");
  });
  $.fn.scrollDivToElement = function(childSel) {
    if (! this.length) return this;

    return this.each(function() {
        let parentEl = $(this);
        let childEl = parentEl.find(childSel);

        if (childEl.length > 0) {
            parentEl.scrollTop(
                parentEl.scrollTop() - parentEl.offset().top + childEl.offset().top - (parentEl.outerHeight() / 2) + (childEl.outerHeight() / 2)
            );
        }
    });
};
  $(document).on('click','.current_currency_name',function () {
     console.log('hellonew1');
    $('.let_content_container').show();
    $('.let_content_container1').hide();
      $(".let_content_container").addClass("active_left_cnt");
    $(this).parents('.container_nav_magamenu').addClass('currency_active');
    $(".mega-menu__list.show_menu_desktop").removeClass("active_sublink");
    $('.language_switcher').removeClass('active_language_switcher');
    $(".mega-menu_custom .mega-menu").removeClass("active-arrow show_arrow");
    $(".left_content_container_sub").addClass("hide_left_content");
    $(".currencies_menu").addClass("active_currency_container");
    $(".currency_switcher_with_contery").removeClass("active_main_currency_switcher" );
    $(".currency_switcher_with_contery").addClass( "active_main_currency_switcher" );
    $('.mega-menu_custom').scrollDivToElement('.active_currency_container');
  });
  $(".currencies_menu .header__menu-item").click(function () {
     console.log('hellonew2');
    var data_country = $(this).attr("data-countery");
    $(".currency_switcher_with_contery .disclosure").removeClass("show_switcher");
    $('.currency_switcher_with_contery .disclosure[data-countery="' +data_country +'"]').addClass("show_switcher");
    
    });
  $(document).on('click','.language_name',function(e){   
      console.log('hellonew');
      $(this).parents('.container_nav_magamenu').addClass('currency_active');
       $('.let_content_container').show();
     $('.mega-menu__list.show_menu_desktop').removeClass('active_sublink');
    $('.mega-menu_custom .mega-menu').removeClass('active-arrow show_arrow');
        $('.left_content_container_sub').addClass('hide_left_content');
    $('.language_switcher').addClass('active_language_switcher');
        $('.currency_switcher_with_contery').removeClass('active_main_currency_switcher');
        $('.currencies_menu').removeClass('active_currency_container');
        $('.currency_switcher_with_contery .disclosure').removeClass('show_switcher');
      $('.mega-menu_custom').scrollDivToElement('.active_language_switcher');
    });
  
  /***** Mega Meun js END ***************/
/************ Mobile menu **************/
$(document).on('click','.mobile_switcher button.disclosure__button',function(e){
  e.preventDefault();
   var metchconteris = $(this).attr('data-attr');
    $('.disclosure__list-wrapper').not($(this).parent('.disclosure').find('.disclosure__list-wrapper')).removeClass('show_mobile_contries');
    $(this).parent('.disclosure').find('.'+metchconteris).toggleClass('show_mobile_contries');   
});
/************ Mobile menu END **************/
  /******** Infomation pop-up js **************/
  $(document).on('click','.icon_main_container .icon',function(){
    $(this).parents('.inner_content_container').find('.main_inner_content').addClass('active');
    var icon_triger = $(this).attr('data-icon');
    $(this).parents('.inner_content_container').find('.main_content_inner').removeClass('active');
     $(this).parents('.inner_content_container').find('.main_content_inner[data-container="'+icon_triger+'"]').addClass('active');
  });

   $(document).on('click','.main_inner_content .sub_inner_content_model .close',function(){
  $(this).parents('.main_inner_content').removeClass('active');
  });
  /******** Infomation pop-up js END**************/

  $(".product_banner_main").click(function () {
    $(this).find(".product_details").toggle();
    $(".product_details").not($(this).find(".product_details")).hide();
  });
  $(document).mouseup(function (e) {
    var container = $(".main_product_content");
    if (!$(".product_banner_main").is(e.target)) {
      if (!container.is(e.target)) {
        $(".product_details").hide();
      }
    }
  });


/************ why this product popup js *************/
  $(document).on('click','.popupOpen,.jdgm-widget.jdgm-preview-badge',function(e){
    e.preventDefault();
   var showDiv= $(this).attr('data-content');
    $("body").addClass('pop-open');
    //$('.'+showDiv).css('display','flex');
    $('.'+showDiv).addClass('active');
  });
  $(document).on('click','.close_popup',function(e){
    e.preventDefault();
    $(this).parents('.model').removeClass('active');
    $("body").removeClass('pop-open');
});

/************ why this product popup js End*************/
/************ why this product popup inner box js *********/
 $(document).on('click','.why-this-product-content .multicolumn-list__item',function(){
     $('.multicolumn-list__item.grid__item').removeClass('active_box');
     $(this).addClass('active_box');
     var click_box = $(this).find('.multicolumn-card').attr('data-attr');
    $(this).parents('.why-this-product-content').find('.result_of_options').removeClass('active_result');
    $(this).parents('.why-this-product-content').find('.result_of_options[data-show="'+click_box+'"]').addClass('active_result');
});
/************ why this product popup inner box js End *********/
/* Copy coupon code for subscription products */
$('body').on('click','.skio-coupon-msg .copy-icon svg',function(){
var copyText = $(this).parents('.skio-coupon-msg').find('.coupon_code');
var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(copyText.text()).select();
  document.execCommand("copy");
  $temp.remove();
  $(this).parents('.skio-coupon-msg').find('.copy_msg').show().delay(1000).fadeOut();

});
/* Copy coupon code END HERE */
   $(document).on('change','.skio-frequency',function(){
      var skioPrice=$(this).parents('.skio-group-container').find('.skio-price').html();
      $(this).parents('.quick-add-modal__content-info' ).find('.quick-popup-price-title .main-price-container .price__regular .price-item.price-item--regular,.main-price-container .price__sale .price-item.price-item--sale').html(skioPrice);
      $(this).parents('.product__info-container').find('.product-form__submit .price ,.product__info-container .main-price-container .price__regular .price-item.price-item--regular,.product__info-container .main-price-container .price__sale .price-item.price-item--sale').html(skioPrice); 
  });
  /** show/hide coupon message on click radio button ***/
 
  $(document).on('change','.skio-group-input',function(){
    $('.skio-group-input').parent('.skio-group-container').removeClass('active_btn');
    $(this).parent('.skio-group-container').addClass('active_btn');
    
if(this.hasAttribute("skio-one-time")){
    $('.skio-coupon-msg').hide();
  
}else{
    $('.skio-coupon-msg').show(); 
$(this).parents('.skio-group-container.skio-group-container--selected').find('.skio-save').show();
}
     var skioPrice=$(this).parents('.skio-group-container.skio-group-container--available.active_btn').find('.skio-price span').html();
     $(this).parents('.quick-add-modal__content-info' ).find('.quick-popup-price-title .price__regular .price-item.price-item--regular, .price__sale .price-item.price-item--sale').html(skioPrice);
      $(this).parents('.product__info-container').find('.product-form__submit .price ,.product__info-container .main-price-container .price__regular .price-item.price-item--regular,.product__info-container .price__sale .price-item.price-item--sale').html(skioPrice);
  });
  /** show/hide coupon message END HERE***/
/** show coupon message on load ***/
  if(!$('.skio-group-input[skio-one-time]').is(':checked')){
     $('.skio-coupon-msg').show(); 
    $('.skio-group-container--selected .skio-save').show();
    if($('.skio-group-container').length > 0){
      var skioPrice=$('.skio-group-container.skio-group-container--selected').find('.skio-price span').html();
      $('.grid__item.product__media-wrapper .quick-popup-price-title .price__regular .price-item.price-item--regular,.quick-popup-price-title .price__sale .price-item.price-item--sale').html(skioPrice);
      $('.product-form__submit .price ,.product__info-container .main-price-container .price__regular .price-item.price-item--regular,.product__info-container .price__sale .price-item.price-item--sale').html(skioPrice);
    }
  } 
/** show coupon message on load ***/
  
/************ FAQ TAB js ************/
$(document).on('click','.accordion',function(){
       $('.accordion').not(this).removeClass('active');
       $('.accordion').not(this).next('.panel').removeClass('show-faq');;
       $(this).toggleClass('active');
       $(this).next('.panel').toggleClass('show-faq');
     });
/************ FAQ TAB js END ************/

 /*** Hide why this heading if no content ***/
  if($('.why-this-product-content').length > 0){
    $('.whyProductTitle').show();
  } 
   /*** Hide why this heading if no content END HERE***/

/************** Footer mobile menu tabs *************/
$(document).on('click','.footer-block__heading',function(){
var window_width = $(window).width();
  if (window_width <= 750) {
    $(this).parent('.footer-block.grid__item.footer-block--menu').find('.footer-block__details-content.list-unstyled').toggle();
    $('.footer-block__details-content.list-unstyled').not($(this).parent('.footer-block.grid__item.footer-block--menu').find('.footer-block__details-content.list-unstyled')).hide()
  }
});
/************** Footer mobile menu tabs END*************/

  /*************** cart drawer js *************/
$(document).on('click','.custom_checkout_btn',function(){
    $('button.cart__checkout-button').show();
    $(this).hide();
    $('cart-drawer-items').hide();
    $('.main_upsell_products').show();
    $('cart-drawer .drawer_upsells').addClass('hide_active');
});
$(document).on('click','.drawer-button_back_btn',function(){
    $('button.cart__checkout-button').hide();
    $('.custom_checkout_btn').show();
    $('cart-drawer-items').show();
    $('.main_upsell_products').hide();
 if(total_show_pd > 0){
   $('cart-drawer .drawer_upsells').removeClass('hide_active');
 }
});
$(document).on('click','.menu-drawer_skip-button',function(){
$('button.cart__checkout-button').trigger('click');
    
});
 /*************** cart drawer js END *************/
   /*************** cart drawer Product add-to-cart-btn Popup close js *************/
$(document).on('click','.quick-add__submit',function(){
    if ($(this).parents('.card-wrapper.product-card-wrapper').find('modal-opener').length >0){

        $('.drawer__close').trigger('click');
    }
    
});
 var flag = 0;
            $('.cart-item').each(function(){
                
             if($(this).attr('data-meta-bundle')=='false' && !$(this).attr('data-item-random') && $(this).attr('data_type') != 'Mobile Case'){
               flag =1 
            }
                
            })
           if(flag == 0 ){
                $('.main-product-type-bundle').addClass('hide_bndl');
            }else if (flag =1 ){
             $('.main-product-type-bundle').removeClass('hide_bndl');
                
            }
setTimeout(function(){
var hide_bndle_notebook_meta = $('.main-bundle-metaobjects .grid__item.bundle-product-list.cart-hidden').length;
var show_bndle_notebook = $('.main-bundle-metaobjects .grid__item.bundle-product-list').length;
var hdie_mobile = $('.main-mobile-bndle .main-bundle-product-container.active_bundel .grid__item.bundle-product-list').length;
var show_mobile = $('.main-mobile-bndle .grid__item.bundle-product-list.cart-hidden').length;
var main_bundle_pd_note_book = $('.main-product-type-bundle').hasClass('hide_bndl');
if(hide_bndle_notebook_meta == show_bndle_notebook && hdie_mobile == show_mobile && main_bundle_pd_note_book == true){
   $('.drawer_upsells').addClass('hide_active');
} 
},100)
/*************** cart drawer Product add-to-cart-btn Popup close js END *************/

/*************** about-us page *************/

if($('.people-list-main').attr('data-show-btn') ==  'true'){
  var showOndesk = parseInt($('.people-list-main').attr('data-inrowdesktop')) * 2;
   var showOnMobile = parseInt($('.people-list-main').attr('data-inrowmobile')) * 2;
  var totalLi = parseInt($('.people-list-main').attr('data-total'));
  if(totalLi > showOndesk && $(window).width() > 989){
     var showOndesk=  showOndesk -1;
    $(`.ty-compact-list:gt(${showOndesk})`).hide();
  }
  else if(totalLi > showOnMobile && $(window).width() < 989){
        var showOnMobile=  showOnMobile -1;
    $(`.ty-compact-list:gt(${showOnMobile})`).hide();
  }
$('.show-more').on('click', function() {
  var showOndesk = parseInt($('.people-list-main').attr('data-inrowdesktop')) * 2;
   var showOnMobile = parseInt($('.people-list-main').attr('data-inrowmobile')) * 2;
  var totalLi = parseInt($('.people-list-main').attr('data-total'));
  //toggle elements with class .ty-compact-list that their index is bigger than 2
  if($(window).width() > 989){
     var showOndesk=  showOndesk -1;
     $(`.ty-compact-list:gt(${showOndesk})`).toggle();
  }else{
     var showOnMobile=  showOnMobile -1;
     $(`.ty-compact-list:gt(${showOnMobile})`).toggle();
  }
 // $('.ty-compact-list:gt(7)').toggle();
  //change text of show more element just for demonstration purposes to this demo
  var btn_text =$.trim($(this).parents('.people_mainsec').attr('data-btn-text'));
  if($(this).text().indexOf(btn_text) > -1){
    $(this).text('Show less') 
  }else{
    $(this).text(btn_text);
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".img_and_text").offset().top - 110
    }, 1000);
  } 
  
});
}
  /*************** end about-us *************/
  
  /************ product page tabs *************/
$(document).on('click','.main_Product_tab_content_container .product_tab',function() {
        $('.main_Product_tab_content_container .accordion__content').not($(this).parents('.main_Product_tab_content_container').find('.accordion__content')).hide();
        $('.main_Product_tab_content_container').not($(this).parents('.main_Product_tab_content_container')).removeClass('open');
        $(this).parents('.main_Product_tab_content_container').toggleClass('open');
        $(this).parents('.main_Product_tab_content_container').find('.accordion__content').slideToggle(function () {
           $('html, body').animate({
                scrollTop: $(this).siblings(".product_tab").offset().top-50
            });
        });

       
    });
/************ product page tabs End*************/
/*** Get read time on article detail page ****/
  function readingTime() {
  const text = $('.article-template').html();
  const wpm = 225;
  const words = text.trim().split(/\s+/).length;
  const time = Math.ceil(words / wpm) + ' mins';
    $('.article-time span').html(time);
 // document.getElementById("time").innerText = time;
}
  if($('.article-time span').length > 0){
readingTime();
  }
  /*** Get read time on article detail page END HERE****/

/***  Chat app code   ***/
  
  /***
     $('.rp-micro-app-dummy-icon').css("display","none");
 $('#rp-home').click(function(){
   $('.rp-micro-app-dummy-icon').css("display","block");
   $('#richpanel_messenger_iframe').css("visibility","visible");
  
 });
***/
 /**** PDP auto slected the variant ***/
if (window.location.href.indexOf('product') > -1){
var queries = {};
 var queryLength =document.location.search.substr(1).split('&').length; 
  $.each(document.location.search.substr(1).split('&'),function(c,q){
if(q.indexOf('=') > -1){
    var i = q.split('=');
    queries[i[0].toString()] = i[1].toString();
    var quryvar = i[1].toString();
  
      if($('.main-product-page').find('.select__select').length > 0){
  if($('.select__select option[data-value="'+quryvar+'"]').length > 0){
    
        $('.main-product-page').find('variant-selects select option').removeAttr('selected','selected'); 
        $('.main-product-page').find('variant-selects select option[data-value="'+quryvar+'"]').attr('selected','selected');  
         if(c== queryLength-1){
           setTimeout(function(){eventFire(document.querySelector('.main-product-page variant-selects select'), 'change');  },500);  
         }
      }
      }else{
 if($('variant-radios .js.product-form__input input[data-value="'+quryvar+'"]').length > 0){
      $('.main-product-page').find('variant-radios .js.product-form__input input[data-value="'+quryvar+'"]').attr('checked','checked'); 
                
         if(c== queryLength-1){
             setTimeout(function(){eventFire(document.querySelector('.main-product-page variant-radios input'), 'change');  },500); 
                 }
 }
}
}
  });    

  function eventFire(el, etype){
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
  
}
 /***** PDP Autoplay video when scroll to that div ****/
if(window.location.href.indexOf('product') > 1){
    var $win = $(window);

    var elementTop, elementBottom, viewportTop, viewportBottom;

    function isScrolledIntoView(elem) {
        elementTop = $(elem).offset().top-200;
        elementBottom = elementTop + $(elem).outerHeight()-200;
        viewportTop = $win.scrollTop()-200;
        viewportBottom = viewportTop + $win.height()-200;
        return (elementBottom > viewportTop && elementTop < viewportBottom);
    }
      $win.on("load scroll", function(e) { 

       if ($('.youtube-container .join-good-fight-section-video.vimeo-video').length > 0) {
            $('.youtube-container .join-good-fight-section-video.vimeo-video').each(function() {
                if (isScrolledIntoView(this) == true) {
                 var iframe = document.querySelector('.join-good-fight-section-video');
                  var player = new Vimeo.Player(iframe);
                    player.play();
                 } else {
                   var iframe = document.querySelector('.join-good-fight-section-video');
                  var player = new Vimeo.Player(iframe);
                    player.pause();
                }
            });
          } 
          else if($('.youtube-container .join-good-fight-section-video.youtube-video').length > 0){
              $(".join-good-fight-section-video.youtube-video").each(function(){
              
               if (isScrolledIntoView(this) == true) {
                   video_first_play ='true';
               var symbol = $(this)[0].src.indexOf("?") > -1 ? "&" : "?";
              $(this)[0].src += symbol + "autoplay=1";
               }
          });  
         }
		});
}
   /***** PDP Autoplay video when scroll to that div ****/
  $(document).on('change','.Add_to_cart_check_box',function(e){
    e.preventDefault();
   
   $(this).parents('.grid__item').find('.product-form form button.product-form__submit').click();
});
});


